import Login from "pages/Auth/Login";
import Page404 from "pages/Page404";
import Home from "pages/Home/Home";
import Users from "pages/Users/Users";
import User from "pages/Users/User";
import MyAccount from "pages/Users/MyAccount";
import ForgotPassword from "pages/Auth/ForgotPassword";
import ResetPassword from "pages/Auth/ResetPassword";

import Plots from "pages/Plots/Plots";
import PlotDetails from "pages/Plots/PlotDetails";
import Zones from "pages/Zones/Zones";
import ZoneDetails from "pages/Zones/ZoneDetails";
import Steps from "pages/Steps/Steps";
import Reviews from "pages/Reviews/Reviews";
import Contacts from "pages/Contacts/Contacts";
import Farmers from "pages/Farmers/Farmers";

const managers = ["SuperAdmin", "Administrateur", "Monitoring"];
const pros = ["SuperAdmin", "Administrateur", "Pro", "Monitoring"];

const routes = [
  {
    path: "/plots",
    roles: managers,
    Component: Plots,
  },
  {
    path: "/plots/:id",
    roles: managers,
    Component: PlotDetails,
  },
  {
    path: "/zones",
    roles: managers,
    Component: Zones,
  },
  {
    path: "/zones/:id",
    roles: managers,
    Component: ZoneDetails,
  },
  {
    path: "/steps",
    roles: managers,
    Component: Steps,
  },
  { path: "/reviews", roles: managers, Component: Reviews },
  { path: "/contacts", roles: managers, Component: Contacts },
  { path: "/farmers", roles: managers, Component: Farmers },
  { path: "/users", roles: managers, Component: Users },
  { path: "/users/add", roles: managers, Component: User },
  { path: "/users/edit/:id", roles: managers, Component: User },
  { path: "/my-account", roles: pros, Component: MyAccount },

  { path: "/", roles: "all", Component: Home },
  { path: "*", roles: "all", exact: false, Component: Page404 },
];

export const loginRoutes = [
  { path: "/login", roles: "all", Component: Login },
  { path: "/forgot-password", roles: "all", Component: ForgotPassword },
  { path: "/reset-password", roles: "all", Component: ResetPassword },
  { path: "/", roles: "all", Component: Login },
  { path: "*", roles: "all", exact: false, Component: Login },
];

export default routes;
